import { useState, useEffect } from 'react'
import styled from 'styled-components'
import { useNavigate, useLocation } from 'react-router-dom'
import { useOnSelectMenu } from 'context/general/OnSelectMenu'
import { useUser } from 'context/user/User'
import { useCollapse } from 'context/general/Collapse'
import paths from 'routes/paths'
import { CheckCircle } from 'react-feather'
import colors from 'theme/colors'
import Text from 'components/_UI/Text'
import Modal from 'components/_UI/Modal'
import { Column } from 'styled/alignment/Column'
import { UpdatePasswordDialog } from 'modules/users/profile/UpdatePasswordDialog'
import Users from 'modules/users/Users'
import EditProfile from 'modules/users/form/EditProfile'
import Checkin from '../checkin/Checkin'
import ROLES from 'helpers/roles'

export default function DashHeaderActions() {
    const navigate = useNavigate()
    const location = useLocation()
    const { onSelectMenu } = useOnSelectMenu()
    const { user } = useUser()
    const { collapse, setCollapse } = useCollapse()
    const [openChangePassword, setOpenChangePassword] = useState(false)
    const [modalSuccessPassword, setModalSuccessPassword] = useState(false)

    const editUser = (user) => {
        setCollapse({
            ...collapse,
            withContent: true,
            height: 'max',
            arrowPosition: false,
            componentToRender: () => <EditProfile data={user} />
        })
    }

    useEffect(() => {
        const { tab } = onSelectMenu || {}

        if (!tab) {
            return
        }

        if (location.pathname === paths.events.home) {
            if (tab === 'checkin') {
                setCollapse({
                    ...collapse,
                    withContent: true,
                    height: 'max',
                    arrowPosition: false,
                    componentToRender: () => (
                        <ContentCheckin>
                            <Checkin minimal withParticipants />
                        </ContentCheckin>
                    )
                })

                return
            }

            if (tab === 'profile') {
                setCollapse({
                    ...collapse,
                    withContent: true,
                    height: 'max',
                    arrowPosition: false,
                    componentToRender: () => <Users home handleEditUser={editUser} />
                })
                
                return
            }
        }


        if (tab === 'checkin') {
            navigate(paths.checkin)

            return
        }

        if (tab === 'profile') {
            if (user.role.id == ROLES.ADMIN) {
                navigate(paths.dashboard.home)

                return
            }

            if (user.role.id == ROLES.PRODUCER) {
                navigate(paths.dashboard.statistics)

                return
            }

            if (user.role.id == ROLES.ESTABLISHMENT) {
                navigate(paths.dashboard.home)

                return
            }

            navigate(paths.user.profile)

            return
        }

        if (tab === 'wallet') {
            navigate(paths.user.wallet)
        }

        if (tab === 'logout') {
            localStorage.removeItem("token");
            localStorage.removeItem("understood");
            window.location.reload()
        }

        if (tab === 'use-terms') {
            navigate(paths.terms.useTerms)
        }

        if (tab === 'change-password') {
            setOpenChangePassword(true)
        }

        if (tab === 'privacy-policies') {
            navigate(paths.terms.policiePrivacy)
        }
    }, [onSelectMenu])

    return (
        <>
            {
                openChangePassword &&
                <UpdatePasswordDialog
                    setModalSucessPassword={setModalSuccessPassword}
                    open={openChangePassword}
                    setOpen={setOpenChangePassword}
                ></UpdatePasswordDialog>
            }

            <Modal isOpen={modalSuccessPassword} onClose={() => setModalSuccessPassword(false)}>
                <ContentModalSucessPassword>
                    <CheckCircle color={colors.successLight} size={'40px'} />
                    <Text color={colors.primaryDashboard} marginTop={'20px'}>
                        Sua senha foi alterada com sucesso!
                    </Text>
                </ContentModalSucessPassword>
            </Modal>
        </>
    )
}

const ContentModalSucessPassword = styled(Column)`
  align-items: center;
`;

const ContentCheckin = styled(Column)`
    height: 100%; 
    & > div:nth-child(2) {
        height: 100%;
        background: ${colors.neutralBackground};
        align-items: flex-start;
        & > div:nth-child(2) {
            background: unset;
            & > div {
                background: ${colors.neutralLight}
            }
        }
    }
   
`;